var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVerifiedTick(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.71 5.67a3 3 0 0 0 1.62 1.62l2.58 1.07a3 3 0 0 1 1.62 3.92l-1.06 2.57a3 3 0 0 0 0 2.3l1.06 2.57a3 3 0 0 1-1.62 3.92l-2.58 1.07a3 3 0 0 0-1.62 1.62l-1.07 2.58a3 3 0 0 1-3.92 1.62l-2.57-1.07a3 3 0 0 0-2.3 0l-2.57 1.07a3 3 0 0 1-3.92-1.62l-1.07-2.58a3 3 0 0 0-1.62-1.62L3.1 23.64a3 3 0 0 1-1.63-3.92l1.07-2.57a3 3 0 0 0 0-2.3l-1.07-2.57A3 3 0 0 1 3.1 8.36l2.58-1.07a3 3 0 0 0 1.62-1.62l1.07-2.58a3 3 0 0 1 3.92-1.62l2.57 1.07a3 3 0 0 0 2.3 0l2.58-1.07a3 3 0 0 1 3.91 1.63l1.07 2.57Z",
    fill: "#0788F5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.27 11.8a1.5 1.5 0 1 0-2.54-1.6l-5.87 9.22-2.69-3.36a1.5 1.5 0 0 0-2.34 1.88l4 5a1.5 1.5 0 0 0 2.44-.13l7-11Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedTick);
export default __webpack_public_path__ + "static/media/verified-tick.b82adebdd9bf3089202266413afd9de4.svg";
export { ForwardRef as ReactComponent };